import { useIntl } from 'react-intl';
import { IconLink } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Tooltip } from '@rossum/ui/material';

type AttachmentsIndicatorProps = {
  onClick: () => void;
  dataCy: string;
};

const AttachmentsIndicator = ({
  onClick,
  dataCy,
}: AttachmentsIndicatorProps) => {
  const intl = useIntl();

  return (
    <Stack
      sx={{ zIndex: 1, cursor: 'pointer' }}
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}
      data-cy={dataCy}
    >
      <Tooltip
        title={intl.formatMessage({
          id: 'components.annotationAttachment.indicator.tooltip',
        })}
        placement="top"
      >
        <SvgIcon fontSize="medium">
          <IconLink />
        </SvgIcon>
      </Tooltip>
    </Stack>
  );
};

export { AttachmentsIndicator };
